export default class FtSaleshFilter {
  constructor(
      isFirstLoad = true,

      id = 0,
      pageNo= 1,
      pageSize = 10,
      sortBy="id",
      order="DESC",
      search="",


      type = 0,
      itemIds =[],

      fdivisionIds =[],
      fsalesmanIds=[],
      fcustomerIds =[],
      fstoreIds =[],
      fexpedisiIds=[],
      statusPengirimanIds =[],
      fmaterialIds=[],
      orderDateFrom= new Date(),
      orderDateTo = new Date(),
      listRemark = [],
      fwarehouseIds = [],

      invoiceDateFrom= new Date(),
      invoiceDateTo = new Date(),
      deliveryDateFrom= new Date(),
      deliveryDateTo = new Date(),

      tipeFakturIds =[],

      tipeFakturJualIds =[],
      listTipeFakturJualString =[],

      trDateFrom= new Date(),
      trDateTo = new Date(),

      fvendorIds=[],

      showFilter =false

  ) {
      this.isFirstLoad = isFirstLoad;

    this.id = id;
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.sortBy = sortBy;
    this.order = order;
    this.search = search;

    this.fdivisionIds = fdivisionIds;
    this.fsalesmanIds = fsalesmanIds;
    this.fcustomerIds = fcustomerIds;
    this.fstoreIds = fstoreIds;
    this.fexpedisiIds = fexpedisiIds;
    this.statusPengirimanIds = statusPengirimanIds;
    this.fmaterialIds = fmaterialIds;
    this.orderDateFrom = orderDateFrom;
    this.orderDateTo = orderDateTo;
    this.listRemark = listRemark;
    this.fwarehouseIds = fwarehouseIds;

    this.type = type;

    this.invoiceDateFrom = invoiceDateFrom;
    this.invoiceDateTo = invoiceDateTo;
    this.deliveryDateFrom = deliveryDateFrom;
    this.deliveryDateTo = deliveryDateTo;

    this.tipeFakturIds = tipeFakturIds;
    this.tipeFakturJualIds = tipeFakturJualIds;
    this.listTipeFakturJualString = listTipeFakturJualString;

    this.itemIds = itemIds;
    this.trDateFrom = trDateFrom;
    this.trDateTo = trDateTo;

    this.fvendorIds = fvendorIds;
    this.showFilter = showFilter;
  }

  setDefaultLastYearRange() {
    const trEnd = this.trDateTo ? new Date(this.trDateTo) : new Date();

    const start = new Date(
      trEnd.getFullYear(),
      trEnd.getMonth() - 6,
      1,
      0, 0, 0, 0
    );

    this.trDateFrom = start;
    this.trDateTo = trEnd;

    this.orderDateFrom = start;
    this.orderDateTo = trEnd;

    this.invoiceDateFrom = start;
    this.invoiceDateTo = trEnd;

    this.deliveryDateFrom = start;
    this.deliveryDateTo = trEnd;
  }

}
